import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CustomCartAvailabilityModel } from "@store/Services/StoreCartService";
import CustomProductAvailabilityState from "@store/Store/Data/CustomProductAvailability/CustomProductAvailabilityState";
import ExplodedViewState from "@store/Store/Data/ExplodedView/ExplodedViewState";
import { Draft } from "immer";

const draft: CustomProductAvailabilityState = {
    customCartAvailability: [],
};
const reducer = {
    "Custom/Cart/CompleteLoadCustomCartAvailability": (
        draft: Draft<CustomProductAvailabilityState>,
        action: { result: CustomCartAvailabilityModel[] },
    ) => {
        draft.customCartAvailability = action.result;
    },
};
export default createTypedReducerWithImmer(draft, reducer);
